const UnMuteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
    >
      <path
        d="M4.82031 7.79297L7.91016 10.5V1.77734L4.82031 4.48438L4.46484 4.8125H1.78516V7.4375H4.46484L4.82031 7.79297ZM0.472656 8.75V3.5H3.97266L7.91016 0H9.22266V12.25H7.91016L3.97266 8.75H0.472656ZM11.6562 8.23047L10.8633 7.19141C11.1914 6.94531 11.4102 6.5625 11.4102 6.125C11.4102 5.71484 11.1914 5.33203 10.8633 5.08594L11.6562 4.04688C12.2852 4.51172 12.7227 5.27734 12.7227 6.125C12.7227 7 12.2852 7.76562 11.6562 8.23047ZM13.2422 10.3359L12.4492 9.29688C13.4062 8.55859 14.0352 7.4375 14.0352 6.125C14.0352 4.83984 13.4062 3.71875 12.4492 2.98047L13.2422 1.94141C14.5 2.89844 15.3477 4.42969 15.3477 6.125C15.3477 7.84766 14.5 9.37891 13.2422 10.3359Z"
        fill="white"
      />
    </svg>
  );
};

export default UnMuteIcon;
